module.exports = __webpack_public_path__ + "img/ordPeeling1.3f4f3283.jpg";